import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { OauthService } from '../../core/oauth.service';
import { environment } from '../../../environments/environment';
@Component({
  selector: 'app-login-access',
  templateUrl: './login-access.component.html',
  styleUrls: ['./login-access.component.css']
})
export class LoginAccessComponent implements OnInit {

  loginForm: FormGroup;
  submitted = false;
  invalidLogin = false;
  userMethodAccess = [];
  users  = {};
  userNames: any;
  userRole: any;
  public email: string;
  currentTimestamp = new Date().getTime();

  oauthData = {
    'username': '',
    'password': '',
    'client_id': '',
    'grant_type': 'password'
  };
  constructor(private router: Router, private fb: FormBuilder, private oauthservice: OauthService) {
    if (this.oauthservice.loggedIn()) {
      this.router.navigate(['dashboard']);
    }
  }
  submitForm() {
    this.submitted = true;
    if (this.loginForm.invalid) {
      return;
    }
    this.oauthData.username = this.loginForm.controls.username.value;
    this.oauthData.password = this.loginForm.controls.password.value;
    this.oauthData.client_id = this.loginForm.controls.username.value;
    this.oauthData.grant_type = 'password';
    this.oauthservice.loginUser(this.oauthData)
      .subscribe(data => {
        this.users = data;
        const accessToken = this.users['access_token'];
        const expiresIn = this.users['expires_in'];
        if (accessToken !== '') {
            sessionStorage.setItem('accessToken', accessToken);
            sessionStorage.setItem('expiresIn', expiresIn);
            const expireTimestamp = this.currentTimestamp + (expiresIn * 1000);
            sessionStorage.setItem('expireTimestamp', '' + expireTimestamp);
            sessionStorage.setItem('user', this.oauthData.username);
            this.oauthservice.httpGet('/user-method-access/' + this.oauthData.username).subscribe( res => {
              sessionStorage.setItem('userMethodAccess', JSON.stringify(res.result.user_access));
              sessionStorage.setItem('userRole', res.result.user_role);
              this.userNames = this.oauthData.username.toLowerCase();
              this.userRole = res.result.user_role;
              sessionStorage.setItem('username', this.userNames);
              if (environment.userLanding[this.userRole] && environment.userLanding[this.userRole][0] !== 'all') {
                this.router.navigate([environment.userLanding[this.userRole][0]]);
              } else {
                if(typeof environment.userLanding[this.userRole] == 'undefined'){
                    this.oauthservice.logoutUser();
                    this.invalidLogin = true;
                    return false;
                }
                console.log(environment.userLanding[this.userRole]);
                this.router.navigate(['dashboard']);
              }
            }, error => {
              this.router.navigate(['dashboard']);
              console.log('error', error);
          });

        } else {
          this.invalidLogin = true;
        }
      }, error => {
        this.invalidLogin = true;
        console.log('error', error);
      });
  }
  ngOnInit() {
    this.loginForm = this.fb.group({
      'username': ['', Validators.required],
      'password': ['', Validators.required]
    });
  }

}
